const pageNameKey = "otaInstallationInProgressModal";

export const otaInstallationInProgressModalEn = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Close installing firmware modal",
    closeModalAriaLabelBackup: "Close installing backup modal",
    titleFirmware: "Installing Firmware",
    titleBackup: "Installing Backup",
    installationDetailsFirmware: "Firmware {itemName}{installationId}",
    installationDetailsBackup: "Backup {itemName}{installationId}",
    installationIdTemplate: " (Installation ID {ID})",
    descriptionFirmware: "Copying files to machine...",
    descriptionBackup: "Copying backup files to machine...",
    waitingBulletPointSecureConnection:
      "Establishing a secure connection to the machine.",
    waitingBulletPointTransferFirmware:
      "Securely transferring the firmware package to the machine.",
    waitingBulletPointCreateBackup:
      "Creating a backup of the existing file structure in the {targetPath}.",
    waitingBulletPointUploadBackup:
      "Uploading the backup to the cloud firmware storage.",
    waitingBulletPointCopyFiles: "Copying files to machine...",
    targetPathFallback: "target path",
    pushInBackgroundButtonText: "Push to Background",
  },
};

export const otaInstallationInProgressModalPtBr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Fechar modal de instalação de firmware",
    closeModalAriaLabelBackup: "Fechar modal de instalação de backup",
    titleFirmware: "Instalando firmware",
    titleBackup: "Instalando backup",
    installationDetailsFirmware: "Firmware {itemName}{installationId}",
    installationDetailsBackup: "Backup {itemName}{installationId}",
    installationIdTemplate: " (ID da instalacao {ID})",
    descriptionFirmware: "Copiando arquivos para a máquina...",
    descriptionBackup: "Copiando arquivos de backup para a máquina...",
    waitingBulletPointSecureConnection:
      "Estabelecendo uma conexão segura com a máquina.",
    waitingBulletPointTransferFirmware:
      "Transferindo com segurança o pacote de firmware para a máquina.",
    waitingBulletPointCreateBackup:
      "Criando um backup da estrutura de arquivos existente em {targetPath}.",
    waitingBulletPointUploadBackup:
      "Enviando o backup para o armazenamento de firmware na nuvem.",
    waitingBulletPointCopyFiles: "Copiando arquivos para a máquina...",
    targetPathFallback: "caminho de destino",
    pushInBackgroundButtonText: "Executar em segundo plano",
  },
};

export const otaInstallationInProgressModalDe = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Modal zur Firmware-Installation schließen",
    closeModalAriaLabelBackup: "Modal zur Backup-Installation schließen",
    titleFirmware: "Firmware wird installiert",
    titleBackup: "Backup wird installiert",
    installationDetailsFirmware: "Firmware {itemName}{installationId}",
    installationDetailsBackup: "Backup {itemName}{installationId}",
    installationIdTemplate: " (Installations-ID {ID})",
    descriptionFirmware: "Dateien werden auf die Maschine kopiert...",
    descriptionBackup: "Backup-Dateien werden auf die Maschine kopiert...",
    waitingBulletPointSecureConnection:
      "Es wird eine sichere Verbindung zur Maschine hergestellt.",
    waitingBulletPointTransferFirmware:
      "Das Firmware-Paket wird sicher zur Maschine übertragen.",
    waitingBulletPointCreateBackup:
      "Es wird eine Sicherung der bestehenden Dateistruktur in {targetPath} erstellt.",
    waitingBulletPointUploadBackup:
      "Die Sicherung wird in den Cloud-Firmware-Speicher hochgeladen.",
    waitingBulletPointCopyFiles: "Dateien werden auf die Maschine kopiert...",
    targetPathFallback: "Zielpfad",
    pushInBackgroundButtonText: "Im Hintergrund ausführen",
  },
};

export const otaInstallationInProgressModalZhHans = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "关闭固件安装弹窗",
    closeModalAriaLabelBackup: "关闭备份安装弹窗",
    titleFirmware: "正在安装固件",
    titleBackup: "正在安装备份",
    installationDetailsFirmware: "固件 {itemName}{installationId}",
    installationDetailsBackup: "备份 {itemName}{installationId}",
    installationIdTemplate: "（安装 ID {ID}）",
    descriptionFirmware: "正在将文件复制到设备...",
    descriptionBackup: "正在将备份文件复制到设备...",
    waitingBulletPointSecureConnection: "正在与设备建立安全连接。",
    waitingBulletPointTransferFirmware: "正在将固件包安全传输到设备。",
    waitingBulletPointCreateBackup:
      "正在为 {targetPath} 中现有的文件结构创建备份。",
    waitingBulletPointUploadBackup: "正在将备份上传到云端固件存储。",
    waitingBulletPointCopyFiles: "正在将文件复制到设备...",
    targetPathFallback: "目标路径",
    pushInBackgroundButtonText: "后台运行",
  },
};

export const otaInstallationInProgressModalIt = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Chiudi finestra di installazione firmware",
    closeModalAriaLabelBackup: "Chiudi finestra di installazione backup",
    titleFirmware: "Installazione firmware",
    titleBackup: "Installazione backup",
    installationDetailsFirmware: "Firmware {itemName}{installationId}",
    installationDetailsBackup: "Backup {itemName}{installationId}",
    installationIdTemplate: " (ID installazione {ID})",
    descriptionFirmware: "Copia dei file sulla macchina in corso...",
    descriptionBackup: "Copia dei file di backup sulla macchina in corso...",
    waitingBulletPointSecureConnection:
      "Connessione sicura alla macchina in corso.",
    waitingBulletPointTransferFirmware:
      "Trasferimento sicuro del pacchetto firmware alla macchina in corso.",
    waitingBulletPointCreateBackup:
      "Creazione di un backup della struttura file esistente in {targetPath}.",
    waitingBulletPointUploadBackup:
      "Caricamento del backup nello storage cloud del firmware.",
    waitingBulletPointCopyFiles: "Copia dei file sulla macchina in corso...",
    targetPathFallback: "percorso di destinazione",
    pushInBackgroundButtonText: "Esegui in background",
  },
};

export const otaInstallationInProgressModalEs = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Cerrar modal de instalación de firmware",
    closeModalAriaLabelBackup: "Cerrar modal de instalación de respaldo",
    titleFirmware: "Instalando firmware",
    titleBackup: "Instalando respaldo",
    installationDetailsFirmware: "Firmware {itemName}{installationId}",
    installationDetailsBackup: "Respaldo {itemName}{installationId}",
    installationIdTemplate: " (ID de instalacion {ID})",
    descriptionFirmware: "Copiando archivos a la máquina...",
    descriptionBackup: "Copiando archivos de respaldo a la máquina...",
    waitingBulletPointSecureConnection:
      "Estableciendo una conexión segura con la máquina.",
    waitingBulletPointTransferFirmware:
      "Transfiriendo de forma segura el paquete de firmware a la máquina.",
    waitingBulletPointCreateBackup:
      "Creando una copia de seguridad de la estructura de archivos existente en {targetPath}.",
    waitingBulletPointUploadBackup:
      "Subiendo la copia de seguridad al almacenamiento en la nube del firmware.",
    waitingBulletPointCopyFiles: "Copiando archivos a la máquina...",
    targetPathFallback: "ruta de destino",
    pushInBackgroundButtonText: "Ejecutar en segundo plano",
  },
};

export const otaInstallationInProgressModalNl = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Firmware-installatiemodal sluiten",
    closeModalAriaLabelBackup: "Back-upinstallatiemodal sluiten",
    titleFirmware: "Firmware installeren",
    titleBackup: "Back-up installeren",
    installationDetailsFirmware: "Firmware {itemName}{installationId}",
    installationDetailsBackup: "Back-up {itemName}{installationId}",
    installationIdTemplate: " (Installatie-ID {ID})",
    descriptionFirmware: "Bestanden worden naar de machine gekopieerd...",
    descriptionBackup: "Back-upbestanden worden naar de machine gekopieerd...",
    waitingBulletPointSecureConnection:
      "Er wordt een beveiligde verbinding met de machine opgezet.",
    waitingBulletPointTransferFirmware:
      "Het firmwarepakket wordt veilig naar de machine overgezet.",
    waitingBulletPointCreateBackup:
      "Er wordt een back-up gemaakt van de bestaande bestandsstructuur in {targetPath}.",
    waitingBulletPointUploadBackup:
      "De back-up wordt geüpload naar de cloudopslag voor firmware.",
    waitingBulletPointCopyFiles:
      "Bestanden worden naar de machine gekopieerd...",
    targetPathFallback: "doelpad",
    pushInBackgroundButtonText: "Op de achtergrond uitvoeren",
  },
};

export const otaInstallationInProgressModalTr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Ürün yazılımı kurulum penceresini kapat",
    closeModalAriaLabelBackup: "Yedekleme kurulum penceresini kapat",
    titleFirmware: "Ürün Yazılımının Yüklenmesi",
    titleBackup: "Yedeklemeyi Yükleme",
    installationDetailsFirmware: "Ürün yazılımı {itemName}{installationId}",
    installationDetailsBackup: "Yedekleme {itemName}{installationId}",
    installationIdTemplate: "(Kurulum Kimliği {ID})",
    descriptionFirmware: "Dosyalar makineye kopyalanıyor...",
    descriptionBackup: "Yedekleme dosyaları makineye kopyalanıyor...",
    waitingBulletPointSecureConnection: "Makineyle güvenli bir bağlantı kurma.",
    waitingBulletPointTransferFirmware:
      "Ürün yazılımı paketinin makineye güvenli bir şekilde aktarılması.",
    waitingBulletPointCreateBackup:
      "{targetPath}'de mevcut dosya yapısının yedeğini oluşturmak.",
    waitingBulletPointUploadBackup:
      "Yedeği bulut ürün yazılımı deposuna yükleme.",
    waitingBulletPointCopyFiles: "Dosyalar makineye kopyalanıyor...",
    targetPathFallback: "hedef yolu",
    pushInBackgroundButtonText: "Arka Plana Bas",
  },
};
